import React, { Component } from "react";
import { useMediaQuery, Typography, Box, Paper } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Logo from "./logo";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
function MobileHeader() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const stepper = useSelector((state) => state.stepper.value);
  const activeStep = stepper.active + 1;
  const stepPercent = (activeStep / stepper.steps.length) * 100;

  const FacebookCircularProgress = () => {
    return (
      <Box sx={{ position: "relative" }}>
        <CircularProgress
          variant="determinate"
          sx={{
            color: (theme) =>
              theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
          }}
          size={55}
          thickness={5}
          value={100}
        />
        <CircularProgress
          variant="determinate"
          sx={{
            animationDuration: "550ms",
            position: "absolute",
            left: 0,
            [`& .${circularProgressClasses.circle}`]: {
              strokeLinecap: "round",
            },
          }}
          value={stepPercent}
          size={55}
          thickness={5}
        />
      </Box>
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={{
          background: (theme) =>
            theme.palette.mode === "light" ? "#fff" : "#373434",

          color: (theme) =>
            theme.palette.mode === "light" ? "#000000" : "#fff",
        }}
        position="static"
      >
        <Toolbar
          sx={{
            padding: (theme) => theme.spacing(2, 0, 2),
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Logo />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "relative",
                display: "inline-flex",
                mr: 1,
              }}
            >
              <FacebookCircularProgress />
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: "absolute",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography sx={{ fontSize: "0.6rem" }}>
                  {`${activeStep} of ${stepper.steps.length}`}
                </Typography>
              </Box>
            </Box>
            <Typography variant="h5" mr={3}>
              {stepper.steps[stepper.active].mobileName}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default MobileHeader;
